import React from "react";
import styles from "../../Style/Managebutton.module.css";

function AddFriendButton({ onButtonClick }) {
  return (
    <button
      className={`${styles.manageButton} add-frn`}
      onClick={onButtonClick}
    >
      Add Friend
    </button>
  );
}

export default AddFriendButton;
